// Shared by the browser, sitemap generator and tests; no DOM or network dependency.
const site = require('./seo');

const staticPages = {
  '/': { title: site.homeTitle, description: site.description, type: 'WebPage' },
  '/choose-course': { title: '产品分类', description: '按类别查找五谷赛信冷链保温箱、PCM相变材料、温湿度记录仪、冷链验证及托盘温控箱，了解产品与应用。', type: 'CollectionPage' },
  '/news-list': { title: '行业资讯', description: '阅读五谷赛信冷链行业资讯、公司动态与冷链温控技术应用信息。', type: 'CollectionPage' },
  '/case-list': { title: '应用案例', description: '了解五谷赛信冷链产品的应用案例与温控包装方案。', type: 'CollectionPage' },
  '/example-list': { title: '应用示范', description: '查看五谷赛信冷链温控产品与技术的应用示范。', type: 'CollectionPage' },
  '/expert-list': { title: '专家团队', description: '了解五谷赛信专家团队与专业介绍。', type: 'CollectionPage' },
  '/partner-list': { title: '合作伙伴', description: '了解五谷赛信合作伙伴。', type: 'CollectionPage' },
  '/siteInfo-detail/1': { title: '公司介绍', description: site.description, type: 'AboutPage', dataKey: 'siteInfoDetail', id: '1' },
  '/siteInfo-detail/2': { title: '联系我们', description: '联系广州赛信冷链冷藏科技有限公司，了解冷链产品选型、技术支持与售后服务。', type: 'ContactPage', dataKey: 'siteInfoDetail', id: '2' },
};
const detailPages = [
  { pattern: /^\/news-detail\/(\d+)$/, dataKey: 'newsDetail', title: '行业资讯详情', parent: '/news-list', type: 'Article' },
  { pattern: /^\/case-detail\/(\d+)$/, dataKey: 'caseDetail', title: '应用案例详情', parent: '/case-list', type: 'WebPage' },
  { pattern: /^\/example-detail\/(\d+)$/, dataKey: 'exampleDetail', title: '应用示范详情', parent: '/example-list', type: 'WebPage' },
  { pattern: /^\/expert-detail\/(\d+)$/, dataKey: 'expertDetail', title: '专家介绍', parent: '/expert-list', type: 'ProfilePage' },
  { pattern: /^\/course-detail\/(\d+)\/(\d+)\/(\d+)$/, dataKey: 'enrollmentDetail', title: '产品详情', parent: '/choose-course', type: 'WebPage', idIndex: 3 },
];

function cleanPath(value) {
  const path = String(value || '/').split(/[?#]/)[0].replace(/\/+$/, '') || '/';
  return path === '/home' ? '/' : path;
}

function getRouteInfo(value) {
  const path = cleanPath(value);
  if (staticPages[path]) return Object.assign({ path }, staticPages[path]);
  const detail = detailPages.find(item => item.pattern.test(path));
  if (detail) return Object.assign({ path, id: path.match(detail.pattern)[detail.idIndex || 1] }, detail);
  const category = path.match(/^\/course-list\/(\d+)\/(\d+)$/);
  if (category) return { path, title: '冷链产品', type: 'CollectionPage', catalog: true, facultyId: category[1], courseId: category[2], parent: '/choose-course' };
  // Account, editing, legacy/hidden technology pages and unknown URLs are not public landing pages.
  const internal = /^\/(web\/|forget-password|user-info|join-|member-|order-|refund-|account-|product-|integral-|evaluation-|config)/.test(path);
  return { path, title: internal ? '用户服务' : '页面未找到', noindex: true };
}

function plainText(value) {
  const entities = { nbsp: ' ', amp: '&', lt: '<', gt: '>', quot: '"', apos: "'" };
  return String(value || '').replace(/<(script|style)\b[^>]*>[\s\S]*?<\/\1\s*>/gi, ' ')
    .replace(/<[^>]*>/g, ' ')
    .replace(/&(#x[\da-f]+|#\d+|nbsp|amp|lt|gt|quot|apos);/gi, (match, code) => {
      if (code[0] !== '#') return entities[code.toLowerCase()] || ' ';
      const point = parseInt(code.slice(code[1].toLowerCase() === 'x' ? 2 : 1), code[1].toLowerCase() === 'x' ? 16 : 10);
      return point > 0 && point <= 0x10ffff && !(point >= 0xd800 && point <= 0xdfff) ? String.fromCodePoint(point) : ' ';
    })
    .replace(/\s+/g, ' ')
    .trim();
}

function shorten(value, limit) {
  return Array.from(plainText(value)).slice(0, limit).join('');
}

function absoluteImage(value) {
  const source = String(value || '').trim();
  if (!source || /^(data|javascript|blob):/i.test(source)) return '';
  if (/^https?:\/\//i.test(source)) return source;
  if (source.indexOf('//') === 0) return `https:${source}`;
  if (source[0] === '/') return site.siteUrl + source;
  return `${site.siteUrl}/api/web/v1/file/${source}`;
}

function validDate(value) {
  const date = String(value || '').slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) return '';
  const parsed = new Date(`${date}T00:00:00Z`);
  return !isNaN(parsed.getTime()) && parsed.toISOString().slice(0, 10) === date ? date : '';
}

function buildMetadata(path, data, menu) {
  const info = getRouteInfo(path);
  const detail = data || {};
  let name = plainText(detail.title || detail.name || info.title);
  if (info.catalog) {
    const faculty = (menu || []).find(item => String(item.id) === info.facultyId);
    const category = faculty && (faculty.child || []).find(item => String(item.id) === info.courseId);
    name = category ? category.name : info.title;
  }
  const canonical = info.noindex ? '' : site.siteUrl + info.path;
  const content = plainText(detail.content).replace(new RegExp(`^${name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\s*`), '');
  const summary = plainText(detail.remark).length > 8 ? detail.remark : content;
  const description = shorten(summary || info.description || `了解${name}，查看五谷赛信的相关介绍与信息。`, 150);
  const title = info.path === '/' ? site.homeTitle : `${name} - ${site.siteName}`;
  const firstImage = String(detail.content || '').match(/<img\b[^>]*\bsrc\s*=\s*["']([^"']+)["']/i);
  const contentImage = absoluteImage(detail.cover || detail.avatar || (firstImage && firstImage[1]));
  const image = contentImage || site.siteUrl + site.logoPath;
  const organization = { '@type': 'Organization', '@id': `${site.siteUrl}/#organization`, name: site.companyName, alternateName: site.siteName, url: `${site.siteUrl}/`, logo: site.siteUrl + site.logoPath };
  const graph = [];
  if (!info.noindex) {
    graph.push(organization);
    graph.push({ '@type': 'WebSite', '@id': `${site.siteUrl}/#website`, name: site.siteName, url: `${site.siteUrl}/`, inLanguage: 'zh-CN', publisher: { '@id': organization['@id'] } });
    const page = { '@type': info.type === 'Article' ? 'WebPage' : info.type, '@id': `${canonical}#webpage`, url: canonical, name, description, inLanguage: 'zh-CN', isPartOf: { '@id': `${site.siteUrl}/#website` } };
    graph.push(page);
    const crumbs = [{ '@type': 'ListItem', position: 1, name: '网站首页', item: `${site.siteUrl}/` }];
    if (info.parent) crumbs.push({ '@type': 'ListItem', position: 2, name: staticPages[info.parent].title, item: site.siteUrl + info.parent });
    if (info.path !== '/') crumbs.push({ '@type': 'ListItem', position: crumbs.length + 1, name, item: canonical });
    if (crumbs.length > 1) graph.push({ '@type': 'BreadcrumbList', itemListElement: crumbs });
    if (info.type === 'Article' && detail.title) {
      const article = { '@type': 'Article', '@id': `${canonical}#article`, headline: name, description, mainEntityOfPage: { '@id': page['@id'] }, publisher: { '@id': organization['@id'] }, inLanguage: 'zh-CN' };
      if (validDate(detail.time)) article.datePublished = validDate(detail.time);
      if (validDate(detail.gmtModified)) article.dateModified = validDate(detail.gmtModified);
      if (contentImage) article.image = [contentImage];
      // No fabricated authors, prices, reviews or publication/update dates.
      graph.push(article);
    }
  }
  return { title, description, canonical, image, robots: info.noindex ? 'noindex, nofollow' : 'index, follow, max-image-preview:large', type: info.type === 'Article' && detail.title ? 'article' : 'website', structuredData: { '@context': 'https://schema.org', '@graph': graph } };
}

module.exports = { site, staticPages, cleanPath, getRouteInfo, plainText, validDate, buildMetadata };



//////////////////
// WEBPACK FOOTER
// ./config/seo-metadata.js
// module id = gLZx
// module chunks = 49